import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ReserveModel} from '@app/models/reserve';
import Reserve = ReserveModel.Reserve;
import {ReservesLeisureResponse} from '@app/models/v3/reserve-leisure';

@Component({
    selector: 'app-discount-tag',
    template: `
        <div *ngIf="reserve && value"
             [pTooltip]="name">
<!--            <p-tag styleClass="mr-2 opacity-90 shadow-4"-->
<!--                   [value]="value| number"-->
<!--                   severity="danger">-->
<!--            </p-tag>-->
            <app-tag [value]="value| number" color="red" size="text-sm"></app-tag>
        </div>
    `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DiscountTagComponent implements OnChanges {
    @Input() reserve: Reserve | ReservesLeisureResponse;

    value: number;
    name: string;

    constructor() {
    }

    ngOnChanges(changes: SimpleChanges): void {
        const discountList = this.getDiscountList(this.reserve);

        if (discountList && discountList.length > 0) {
            const discount = discountList[0];
            this.value = discount.money;
            this.name = discount.desc;
        }
    }

    private getDiscountList(reserve: Reserve | ReservesLeisureResponse) {
        return reserve?.discountList;
    }
}
